// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ltg-app-header--loading{height:70px}", "",{"version":3,"sources":["webpack://./assets/spa/layout/header/header.scss"],"names":[],"mappings":"AAEI,yBACI,WAAA","sourcesContent":["$ltg-theme:\"infra\";\n.ltg-app-header{\n    &--loading{\n        height: 70px;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
